<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/protocoloEntrega">
        Manutenção/Protocolo Entrega
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-col cols="12" sm="3">
          <v-subheader><strong>Saída</strong></v-subheader>
          <hr />
          <div class="flex-center">
            <v-radio-group v-model="saida" row>
              <v-radio label="Interna" value="I"></v-radio>
              <v-radio label="Externa" value="E"></v-radio>
            </v-radio-group>
          </div>
        </v-col>
        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="unidadeAdmSelected"
              :items="filteredUnidAdm"
              label="Unidade Administrativa *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Unidade Administrativa é obrigatória']"
              required
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Veículo" v-model="veiculo"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Motorista" v-model="motorista"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12">
            <v-textarea
              clearable
              auto-grow
              clear-icon="mdi-close-circle"
              label="Informações adicionais"
              v-model="observacao"
              maxlength="200"
              counter
              rows="1"
              :rules="[
                (v) =>
                  !v ||
                  v.length <= 200 ||
                  'Observação deve possuir no máximo 200 caracteres',
              ]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>

      <v-row align="center">
        <v-col class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                fab
                small
                v-bind="attrs"
                v-on="on"
                @click="addProduto()"
                class="white--text"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Adicionar produto</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-form ref="formProd" v-model="valid" lazy-validation>
        <v-card>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="produtosL"
            item-key="index"
            :items-per-page="-1"
          >
            <template v-slot:item.codigo="{ item }">
              {{
                item.codigo === null || item.codigo == "" ? "NA" : item.codigo
              }}
            </template>
            <template v-slot:item.quantidade="{ item }">
              <v-text-field
                v-model="item.quantidade"
                hide-details
                dense
                type="number"
                :rules="[validarQuantidadeItem]"
                v-mask="['#####']"
              />
            </template>
            <template v-slot:item.centroCusto="{ item }">
              <div v-if="!item.editingCentroCusto">
                <div
                  @click="item.editingCentroCusto = true"
                  style="cursor: pointer"
                >
                  {{
                    (item.centroCustoSelected &&
                      item.centroCustoSelected.descricao) ||
                    "Selecionar..."
                  }}
                </div>

                <div
                  v-if="item.centroCustoErro"
                  style="color: #b00020; font-size: 12px"
                >
                  O Centro de Custo é obrigatório
                </div>
              </div>

              <v-autocomplete
                v-else
                v-model="item.centroCustoSelected"
                :items="centrosCusto"
                item-text="descricao"
                item-value="id"
                return-object
                :readonly="isAllowed"
                autofocus
                @blur="
                  () => {
                    item.editingCentroCusto = false;
                    item.centroCustoErro = !(
                      item.centroCustoSelected && item.centroCustoSelected.id
                    );
                  }
                "
                @change="
                  (val) => {
                    changeProduto(item, val);
                    item.centroCustoErro = !(val && val.id);
                    item.editingCentroCusto = false;
                  }
                "
                :rules="[
                  (v) => !!(v && v.id) || 'O Centro de Custo é obrigatório',
                ]"
                required
              />
            </template>
            <template v-slot:item.requisicao="{ item }">
              <v-text-field v-model="item.requisicao"></v-text-field>
            </template>
            <template v-slot:item.solicitante="{ item }">
              <v-text-field v-model="item.solicitante"></v-text-field>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    color="error"
                    @click="removeProduto(item.index)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-thick
                  </v-icon>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
            <template v-slot:item.index="{ item }">
              {{ item.index + 1 }}
            </template>
            <template v-slot:body.append>
              <tr>
                <td
                  :colspan="headers.length"
                  class="text-right font-weight-medium"
                >
                  Total de itens: {{ produtosL.length }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-form>
      
      <v-row align="center-left">
        <v-col class="text-right">
          <v-speed-dial bottom right fixed>
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>done</v-icon>
              </v-btn>
            </template>
            <v-btn @click="enviar" color="success" class="mr-4">Salvar</v-btn>
            <v-btn to="/protocoloEntrega" color="error" class="mr-4">Voltar</v-btn>
          </v-speed-dial>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog
      style="z-index: 9999"
      v-model="showModal"
      persistent
      max-width="1000px"
      ><v-card>
        <v-card-title>
          <span class="headline">Adicionar Produto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form2" v-model="validFrm2" lazy-validation>
              <produto
                ref="prdAdd"
                :produtosL="produtosL"
                :showModal="showModal"
              />
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions
          style="position: sticky; bottom: 0; background: white; z-index: 1"
        >
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { enviarProtocoloEntregaAsync } from "../../../services/protocoloEntregaService";
import { mapState, mapActions } from "vuex";
import Produto from "./Produto";

export default {
  name: "criarProtocoloEntrega",
  data: () => ({
    overlay: false,
    valid: true,
    validFrm2: true,
    saida: "I",
    unidadeAdmSelected: null,
    veiculo: null,
    motorista: null,
    observacao: null,
    produtosL: [],
    showModal: false,
    headers: [
      { text: "Item", value: "index", sortable: false },
      { text: "Item", value: "descricao", sortable: false },
      { text: "Tipo", value: "tipoProdutoServico", sortable: false },
      { text: "Cod. Fabricante", value: "codigo", sortable: false },
      { text: "Und.", value: "unidadeMedida", sortable: false },
      { text: "Quantidade", value: "quantidade", sortable: false },
      {
        text: "Centro de Custo",
        align: "start",
        value: "centroCusto",
        title: "tooltip",
      },
      { text: "Requisição", value: "requisicao", sortable: false },
      { text: "Solicitante", value: "solicitante", sortable: false },
      { text: "", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapState("protocoloEntrega", ["protocoloEntrega"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
  },
  methods: {
    ...mapActions("produto", ["atualizarListaProdutos"]),
    async enviar() {
      const quantidadesOk = this.validarQuantidadeItens();

      if (!quantidadesOk) {
        this.errorMessageValue =
          "Informe uma quantidade maior que zero em todos os itens.";
        this.errorMessage = true;
        if (this.$store) {
          this.$store.dispatch("ui/showSnackbar", {
            text: "Informe uma quantidade maior que zero em todos os itens.",
            color: "error",
            timeout: 3000,
          });
        }
        return;
      }

      const centrosOk = this.validarCentroCustoItens();

      if (!centrosOk) {
        // bloqueia envio
        // opcional: toast/snackbar
        this.errorMessageValue =
          "Preencha o Centro de Custo em todos os itens.";
        this.errorMessage = true;
        this.$store.dispatch("ui/showSnackbar", {
          text: "Preencha o Centro de Custo em todos os itens.",
          color: "error",
          timeout: 3000,
        });
        return;
      }
      if (this.produtosL == null || this.produtosL.length <= 0) {
        this.errorMessageValue = "Adicione os produtos!";
        this.errorMessage = true;
        this.$store.dispatch("ui/showSnackbar", {
          text: "Adicione os produtos.",
          color: "error",
          timeout: 3000,
        });
      } else if (this.$refs.form.validate() && this.$refs.formProd.validate()) {
        this.overlay = true;
        try {
          const resposta = await enviarProtocoloEntregaAsync(
            this.saida,
            this.unidadeAdmSelected.id,
            this.veiculo,
            this.motorista,
            this.observacao,
            this.produtosL
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message || "",
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            this.$router.push("/protocoloEntrega");
          }
        } finally {
          this.overlay = false;
        }
      } else {
        this.$store.dispatch("ui/showSnackbar", {
          text: "Preencha os itens obrigatórios.",
          color: "error",
          timeout: 3000,
        });
      }
    },
    addProduto: function () {
      this.showModal = true;
    },
    removeProduto(index) {
      this.produtosL = this.produtosL.filter((p) => p.index != index);
    },

    changeProduto(item, centroCusto) {
      item.idCentroCusto = centroCusto.id;
      item.centroCusto = centroCusto.descricao;
    },
    async obterListas() {
      await this.atualizarListaProdutos();
    },

    validarQuantidadeItem(quantidade) {
      return Number(quantidade) > 0 || "A quantidade deve ser maior que zero";
    },
    validarQuantidadeItens() {
      return this.produtosL.every(
        (item) => this.validarQuantidadeItem(item.quantidade) === true
      );
    },
    validarCentroCustoItens() {
      this.produtosL.forEach((i) => {
        if (i.centroCustoSelected && i.centroCustoSelected.id) {
          i.idCentroCusto = i.centroCustoSelected.id;
          i.centroCusto = i.centroCustoSelected.descricao;
        }

        i.centroCustoErro = !(i.centroCusto && i.idCentroCusto);
      });

      return this.produtosL.every((i) => i.centroCusto && i.idCentroCusto);
    },
  },
  created: function () {
    this.obterListas();
  },
  components: {
    Produto,
  },
};
</script>
